import { HttpErrorResponse, HttpEventType, HttpInterceptorFn } from '@angular/common/http';
import { inject } from '@angular/core';
import { catchError, tap, throwError } from 'rxjs';

import { ConnectivityService } from './connectivity.service';

export const networkErrorInterceptor: HttpInterceptorFn = (req, next) => {
  const connectivity = inject(ConnectivityService);
  return next(req).pipe(
    tap((event) => {
      if (event.type === HttpEventType.Response) connectivity.isOnline.set(true);
    }),
    catchError((err) => {
      const networkDown = err instanceof HttpErrorResponse && err.status === 0;
      connectivity.isOnline.set(!networkDown);
      return throwError(() => err);
    }),
  );
};
